import { useMemo } from "react";

import type { ComposerContextChip } from "@/features/caseIde/chat/components/Composer";

import { kindLabel } from "../refs/entityRefs";
import { onScreenKey } from "./onScreen";
import { onScreenIcon } from "./onScreenIcon";
import { onScreenStore } from "./onScreenStore";
import { useOpenOnScreen } from "./useOnScreen";

/**
 * The composer chip for the record the next turn will send (null: none, or
 * `shown` is off). Removing it keeps that record out until the page shows
 * another one.
 */
export const useOnScreenChip = (shown: boolean): ComposerContextChip | null => {
  const open = useOpenOnScreen();
  return useMemo(() => {
    if (!shown || !open) return null;
    const kind = kindLabel({ kind: open.kind, focusKey: open.focus_key });
    const selected = open.selected_node_ids?.length ?? 0;
    const key = onScreenKey(open);
    return {
      icon: onScreenIcon(open.kind),
      label: open.label || kind,
      kind,
      detail: selected ? `${selected} selected` : null,
      onRemove: () => onScreenStore.dismiss(key)
    };
  }, [shown, open]);
};
